import React from "react";
import { useSalesPersons } from "../../hooks/usePersonsData";
import { useUpdateCustomerSalesResponsibleMutation } from "../../store/services/customerService";
import AssignPersonDialog from "./AssignPersonDialog";

interface AssignSalesDialogProps {
  open: boolean;
  onClose: () => void;
  customerNo: number;
  currentSalesPersonId?: number | null;
}

const AssignSalesDialog: React.FC<AssignSalesDialogProps> = ({
  open,
  onClose,
  customerNo,
  currentSalesPersonId,
}) => {
  const { persons, isLoading } = useSalesPersons();
  const [updateSales] = useUpdateCustomerSalesResponsibleMutation();

  const handleAssign = async (personId: number | null) => {
    if (!personId) return; // Sales person cannot be null in this case

    try {
      await updateSales({
        customerNo: customerNo,
        CustomerSalesResponsibleId: personId,
      }).unwrap();
    } catch (error) {
      console.error("Error assigning sales person:", error);
      throw error;
    }
  };

  return (
    <AssignPersonDialog
      open={open}
      onClose={onClose}
      title="Ändra säljare"
      label="Ny säljare"
      currentPersonId={currentSalesPersonId}
      persons={persons}
      isLoading={isLoading}
      onAssign={handleAssign}
      allowClear={false} // Sales person cannot be removed
    />
  );
};

export default AssignSalesDialog;
